/** Shared designer/boutique catalogue media allowlists (web). */

export const SHOP_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/heic',
  'image/heif',
];

export const SHOP_VIDEO_TYPES = [
  'video/mp4',
  'video/quicktime',
  'video/webm',
  'video/x-m4v',
];

export const SHOP_MEDIA_TYPES = [...SHOP_IMAGE_TYPES, ...SHOP_VIDEO_TYPES];

export const MAX_SHOP_IMAGE_BYTES = 10 * 1024 * 1024;
export const MAX_SHOP_VIDEO_BYTES = 50 * 1024 * 1024;

export const SHOP_MEDIA_ACCEPT = 'image/*,video/mp4,video/quicktime,video/webm,video/x-m4v,.mp4,.mov,.webm,.m4v';

export function isShopVideoFile(file) {
  if (!file) return false;
  if ((file.type || '').startsWith('video/')) return true;
  const name = (file.name || '').toLowerCase();
  return /\.(mp4|mov|webm|m4v)$/.test(name);
}

export function validateShopMediaFiles(files) {
  const valid = [];
  const errors = [];
  for (const file of files) {
    const isVideo = isShopVideoFile(file);
    const isImage = (file.type || '').startsWith('image/') || SHOP_IMAGE_TYPES.includes(file.type);
    if (!isVideo && !isImage) {
      errors.push(`"${file.name}" is not a supported photo or video.`);
      continue;
    }
    if (isImage && file.type && !SHOP_IMAGE_TYPES.includes(file.type) && !file.type.startsWith('image/')) {
      errors.push(`"${file.name}" has an unsupported image format.`);
      continue;
    }
    if (isVideo && file.type && !SHOP_VIDEO_TYPES.includes(file.type) && !file.type.startsWith('video/')) {
      errors.push(`"${file.name}" has an unsupported video format. Use MP4, MOV, or WebM.`);
      continue;
    }
    const maxBytes = isVideo ? MAX_SHOP_VIDEO_BYTES : MAX_SHOP_IMAGE_BYTES;
    if (file.size > maxBytes) {
      errors.push(`"${file.name}" is too large (max ${maxBytes / (1024 * 1024)}MB).`);
      continue;
    }
    valid.push(file);
  }
  return { valid, errors };
}

export function countShopImageFiles(entries) {
  return (entries || []).filter((entry) => {
    const file = entry?.file || entry;
    return file && !isShopVideoFile(file);
  }).length;
}
